<template>
  <div class="download-btn-box download-btn-box-big z-index-1">
    <div class="download-btn" v-bind:class="{ 'disabled': processingDownload === true || currentJob.state === 'failed' || currentJob.state === 'not_found' || currentJob.state === 'unauthorized' || currentJob.state === 'cancelled'}"
   >
      <a class="d-flex gap-10px align-items-center download-btn-main download-btn-primary"  @click="downloadJob" :href="downloadLink">
        <svg v-if="!processingDownload && currentJob.state !== 'downloaded'" xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 19 21" fill="none">
          <path d="M19 7.41176H13.5714V0H5.42857V7.41176H0L9.5 16.0588L19 7.41176ZM0 18.5294V21H19V18.5294H0Z" fill="white"/>
        </svg>
        <i v-if="processingDownload" class="fa fa-spin btn-loading-animation"></i>
        <svg v-if="currentJob.state === 'downloaded'" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
          <path d="M12 2.75C14.5859 2.75 17.0658 3.77723 18.8943 5.60571C20.7228 7.43419 21.75 9.91414 21.75 12.5C21.75 15.0859 20.7228 17.5658 18.8943 19.3943C17.0658 21.2228 14.5859 22.25 12 22.25C9.41414 22.25 6.93419 21.2228 5.10571 19.3943C3.27723 17.5658 2.25 15.0859 2.25 12.5C2.25 9.91414 3.27723 7.43419 5.10571 5.60571C6.93419 3.77723 9.41414 2.75 12 2.75ZM12 24.5C15.1826 24.5 18.2348 23.2357 20.4853 20.9853C22.7357 18.7348 24 15.6826 24 12.5C24 9.3174 22.7357 6.26516 20.4853 4.01472C18.2348 1.76428 15.1826 0.5 12 0.5C8.8174 0.5 5.76516 1.76428 3.51472 4.01472C1.26428 6.26516 0 9.3174 0 12.5C0 15.6826 1.26428 18.7348 3.51472 20.9853C5.76516 23.2357 8.8174 24.5 12 24.5ZM17.2969 10.2969C17.7375 9.85625 17.7375 9.14375 17.2969 8.70781C16.8563 8.27188 16.1438 8.26719 15.7078 8.70781L10.5047 13.9109L8.30156 11.7078C7.86094 11.2672 7.14844 11.2672 6.7125 11.7078C6.27656 12.1484 6.27187 12.8609 6.7125 13.2969L9.7125 16.2969C10.1531 16.7375 10.8656 16.7375 11.3016 16.2969L17.2969 10.2969Z" fill="white"/>
        </svg>
        {{ 'Download' | trans }}
      </a>

      <div class="download-btn-dropdown" v-if="resultPage.isMobile === false" @click="dropdownActive = !dropdownActive">
        <i class="far fa-chevron-down" v-if="!dropdownActive"></i>
        <i class="far fa-chevron-up" v-if="dropdownActive"></i>
      </div>
      
      <div class="download-btn-dropdown" v-if="resultPage.isMobile === true" @click="dropdownActive = !dropdownActive">
        <i class="far fa-chevron-up" v-if="!dropdownActive"></i>
        <i class="far fa-chevron-down" v-if="dropdownActive"></i>
      </div>

      <div id="download-dropdown" class="" v-if="dropdownActive && currentJob.state !== 'failed' && currentJob.state !== 'not_found' && currentJob.state !== 'processing' && currentJob.state !== 'unauthorized'">

        <div class="dropdown-item">
          <span
              id="downloadZipButton"
              title="Download as ZIP"
              class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
              @click.prevent="downloadJobAsZip"
          >
             <span class="px-75">
               <i class="far fa-file-archive"></i> </span> Download as ZIP
          </span>
        </div>
        <div class="dropdown-divider"></div>

        <div class="dropdown-item">
          <span
              id="dropboxButton"
              title="Choose one or more files from Dropbox"
              class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
              @click.prevent="uploadJobToDropbox"
          >
            <span class="px-75">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 40" version="1.1" width="15px">
                <path d="m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z" fill="#007EE5"></path></svg>
            </span> {{'Upload to Dropbox'|trans}}
          </span>
        </div>

        <div class="dropdown-divider"></div>

        <div class="dropdown-item" @click.prevent="uploadJobToGdrive">
          <span
              id="gdriveButton" title="Choose one or more files from Google Drive"
              class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center">
            <span class="px-75"><svg width="15px" viewBox="0 0 87.3 78" xmlns="http://www.w3.org/2000/svg">
              <path d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z" fill="#0066da"></path>
              <path d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z" fill="#00ac47"></path>
              <path d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z" fill="#ea4335"></path>
              <path d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d"></path>
              <path d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc"></path>
              <path d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00"></path></svg>
            </span> {{'Upload to Google Drive'|trans}}
        </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import DownloadManager from "../../manager/DownloadManager";
import {JOB_STATE_ZIP} from "../../const/job.const";
import Gdrive from "../../util/Gdrive";
import DropboxSaver from "../../util/DropboxSaver";
import Analytics from "../../util/Analytics";
import OutputSelectionManager from '../../manager/OutputSelectionManager';

export default {
  name: "DownloadBtn",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
      dropdownActive: false,
      listener: false
    };
  },
  mounted: function () {
    if (this.listener !== true) {
      this.listener = true;
      document.body.addEventListener('click', ((event) => {
        let dropdown = document.querySelector('.download-btn-box-big');
        if (dropdown?.contains(event.target) === false) {
          this.dropdownActive = false;
        }
      }));
    }
  },
  created: function () {
  },
  methods: {
    async downloadJobAsZip() {
      if (this.currentJob.state !== 'completed') {
        return;
      }
      this.dropdownActive = false;

      if (OutputSelectionManager.getSelectedOutputs(this.currentJob).length > 0 
          && OutputSelectionManager.getSelectedOutputs(this.currentJob).length < OutputSelectionManager.getAllOutputs(this.currentJob).length ) {
          Analytics.send('result_download', 'secondary_zip', this.currentJob);
          await DownloadManager.downloadSelectedOutputsAsZip(this.currentJob.id);
        return;
      }

      Analytics.send('result_download', 'primary_zip_dropdown', this.currentJob);

      await DownloadManager.downloadJobAsZip(this.currentJob.id);
    },
    async downloadJob() {
      if (this.currentJob.state !== 'completed' && this.currentJob.state !== 'uploading-completed') {
        return;
      }

      this.dropdownActive = false;

      if (this.currentJob.apiJob.output.length === 1) {
        Analytics.send('result_download', 'primary_single', this.currentJob);

        await DownloadManager.downloadOutput(this.currentJob.apiJob.output[0], this.currentJob);
        return;
      }

      if (OutputSelectionManager.getSelectedOutputs(this.currentJob).length === 1) {
        Analytics.send('result_download', 'primary_single', this.currentJob);
        await DownloadManager.downloadOutput(OutputSelectionManager.getSelectedOutputs(this.currentJob)[0], this.currentJob)
        return;
      }

      if (OutputSelectionManager.getSelectedOutputs(this.currentJob).length > 1 
          && OutputSelectionManager.getSelectedOutputs(this.currentJob).length < OutputSelectionManager.getAllOutputs(this.currentJob).length ) {
          Analytics.send('result_download', 'secondary_zip', this.currentJob);
          await DownloadManager.downloadSelectedOutputsAsZip(this.currentJob.id);
        return;
      }

      Analytics.send('result_download', 'primary_zip', this.currentJob);

      await DownloadManager.downloadJobAsZip(this.currentJob.id);
    },
    uploadJobToGdrive() {
      if (this.currentJob.state !== 'completed' && this.currentJob.state !== 'uploading-completed') {
        return;
      }
      this.dropdownActive = false;
      Gdrive.uploadJob(this.currentJob);
    },
    uploadJobToDropbox() {
      if (this.currentJob.state !== 'completed' && this.currentJob.state !== 'uploading-completed') {
        return;
      }
      this.dropdownActive = false;
      DropboxSaver.uploadJob(this.currentJob);
    }
  },
  computed: {
    downloadLink() {
      if (this.currentJob.apiJob === null) {
        return '#';
      }

      if (this.currentJob.apiJob.output.length === 1) {
        return this.currentJob.apiJob.output[0].download_uri;
      }

      if (this.currentJob.apiJob.output.length > 1) {
        return this.currentJob.zipJob?.output[0].download_uri;
      }

      return '#';
    },
    processingDownload() {
      if (this.currentJob.state === JOB_STATE_ZIP) {return true;}
      if (this.loading) { return true ;}
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
#download-dropdown {
  position:absolute;
  background: white;
  top: 63px;
  border-left:2px solid #1266F1;
  border-bottom:2px solid #1266F1;
  border-right:2px solid #1266F1;
  width: 100%;
  border-radius: 0 0 4px 4px;
  overflow: hidden;
  z-index: 1;

  #layout-base-mobile & {
    top: -197px;
    border-radius: 4px 4px 0 0;
    border-left: 2px solid #1266F1;
    border-bottom: none;
    border-right: 2px solid #1266F1;
    border-top: 2px solid #1266F1;
  }
}
.download-btn-main {
  padding: 0 20px;
  z-index: 5;
  flex: 1 1 auto;
  height: 100%;
  color: white;
}

.dropdown-item {
  padding: 10px 10px;
}
.download-btn-dropdown {
  border-left: 2px solid #1158cd;
  height: 100%;
  align-items: center;
  display: inline-flex;
  padding: 0 30px;
  user-select: none
}
.download-btn {
  padding: 0;
  background: #1266F1;
  color: white;
  height: 65px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  font-size: 17.5px;
  font-weight: 600;
  cursor: pointer;
  position:relative;

  &:hover {
    background: #1161e5;
  }
}

.disabled {
  opacity: .5;
  cursor: not-allowed;
}
</style>
